import * as React from "react";
import {handleNavigation, routePaths} from "egold/routes";
import {imageBaseUrl} from "config";
import {useEffect} from "react";
import {AndroidApis} from "app";
import {IReduxState} from "reducers";
import {useSelector} from "react-redux";

export function OrderFail() {
    const isAndroid: boolean = useSelector((state: IReduxState) => state.login.isAndroid);
    useEffect(() => {
        clearStack();
        return () => clearStack();
    }, []);
    function clearStack() {
        if (isAndroid) {
            AndroidApis.clearWebStack();
        }
    }
    return (
        <div style={{marginTop: "45%", color: "#000000"}}>
            <div className="text-center">
                <img src={`${imageBaseUrl}/img/icons/eGold/error.png`} width={100}/>
                <p className="mt-3 mb-0 text-danger">Order Unsuccessful</p>
                <small className="d-block ">Please try again !</small>
                <div className="text-center mt-5"
                     onClick={() => handleNavigation(routePaths.BUY_GOLD)}>
                    <span className="go-to-dash">Go to Dashboard</span>
                </div>
            </div>
        </div>
    );
}
